/* unplugin-vue-components disabled */import script from "./micrositeHero.vue?vue&type=script&lang=js"
export * from "./micrositeHero.vue?vue&type=script&lang=js"

import "./micrositeHero.vue?vue&type=style&index=0&id=0a6bddb8&lang=scss"

const __exports__ = script;

export default __exports__